<template>
  <div class="options">
    <button class="dots" @click="toggleDropdown" :class="dropDownOpen ? 'dots--selected' : ''">
      <IconBase icon-name="dots" iconColor="#666" viewBox="0 0 24 24" width="100%" height="100%" strokeWidth="0px"><IconDots /></IconBase>
    </button>
    <SettingsAreaPrivacyOptions v-if="dropDownOpen" @unexclude="unexclude" @unblock="unblock" @editExclusion="editExclusion" @block="block" :type="type" />
  </div>
</template>
<script>
import IconBase from "../../components/IconBase.vue";
import IconDots from "../../components/SVG/IconDots.vue";
import SettingsAreaPrivacyOptions from "./SettingsAreaPrivacyOptions.vue";

import CloseComponent from "@/mixins/CloseComponent";

export default {
  name: "PrivacyOptionsButton",

  mixins: [CloseComponent],

  props: {
    type: String,
  },

  components: {
    IconBase,
    IconDots,
    SettingsAreaPrivacyOptions,
  },
  computed: {
    dropDownOpen() {
      return this.componentOpen; /* from mixin */
    },
  },
  methods: {
    toggleDropdown() {
      /* wrapper for mixin */
      this.toggleComponent();
    },
    unexclude() {
      this.$emit("unexclude");
      this.componentOpen = false;
    },
    editExclusion() {
      this.$emit("editExclusion");
      this.componentOpen = false;
    },
    unblock() {
      this.$emit("unblock");
      this.componentOpen = false;
    },
    async block() {
      this.$emit("block");
      this.componentOpen = false;
    },
  },
};
</script>

<style scoped>
.dots {
  width: 34px;
  height: 34px;
  position: absolute;
  right: 20px;
  border-radius: 360px;
  padding: 8px;
  bottom: 21.5px;
  background-color: transparent;
  transition: 0.1s ease-in-out;
}
.dots:hover,
.dots--selected {
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255 / 80%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}

.dots svg {
  transform: rotate(90deg);
}

@media screen and (max-width: 1180px) {
  .dots {
    right: 75px;
  }
}
@media scree and (max-width: 1080px) {
  .dots {
    right: 20px;
  }
}
</style>
